import React from "react";
import { pageContainerStyle, pageHeadingStyle } from "./Style";

type PageLayoutProps = {
  title?: React.ReactNode;
  actionRows?: React.ReactNode[];
  children?: React.ReactNode | React.ReactNode[];
};

function PageLayout({ title, actionRows, children }: PageLayoutProps) {
  const validActionRows = (actionRows || []).filter(Boolean);

  return (
    <div style={{ ...pageContainerStyle, display: "flex", flexDirection: "column", gap: 12 }}>
      {title && <h2 style={pageHeadingStyle}>{title}</h2>}

      {validActionRows.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 0, width: "100%" }}>
          {validActionRows.map((row, idx) => (
            <div
              key={idx}
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              {row}
            </div>
          ))}
        </div>
      )}

      <div style={{ width: "100%" }}>{children}</div>
    </div>
  );
}

export default PageLayout;
